import AutoTooltips from './slick.autotooltips';
export default AutoTooltips;
